import React from 'react'

export function PageSectionTitle({
  sectionName,
  description,
}: {
  sectionName: string;
  description?: string;
}) {
  return (
    <div className="flex flex-col justify-start items-center  mb-6">
      <h2 className="text-lg md:text-xl text-center sm:text-left font-bold">
        {sectionName}
      </h2>
      {description ? <p className="text-muted-foreground text-center sm:text-left">{description}</p> : <div className="size-8"></div>}
    </div>
  )
}
